import {
  Box,
  Button,
  Grid,
  List,
  ListItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { myLocalStorage } from "../../../../components/StorageHelper";
import moment from "moment";
import SyncIcon from "@mui/icons-material/Sync";
import { awsIcons } from "../../AWS/AWSIcons";
import AzureUserGroups from "./AzureUserGroups";
import { NGROK } from "../../../../APIs";
import axios from "axios";
import useUserStore from "../../../../services/userStore";
import TailwinButton from "../../../../tailwind-ui/components/TailwinButton";
import { AiOutlineBarChart } from "react-icons/ai";
import { FaServer } from "react-icons/fa";
import useCloudSyncStore from "../../../../services/useCloudSyncStore";
import { triggerCloudSync } from "../../../../triggerCloudSync";
import useNotificationStore from "../../../../services/notificationStore";
import TailwindFilterHeader from "../../../../tailwind-ui/components/TailwindFilterHeader";
import UserRoleAnalysis from "../../GCP/Components/UserRoleAnalysis";
import TailwindCollapsibleTable from "../../../../tailwind-ui/components/TailwindCollapsibleTable";
import TimelineIcon from "@mui/icons-material/Timeline";
import { User2Icon } from "lucide-react";
import CloudEntityAnalytics from "../../../../components/v2components/CloudAnalytics/CloudEntityAnalytics";

const AzureUserInfo = () => {
  const location = useLocation();
  const { user: initialUser } = location.state || { user: {} };
  const latestTenant = myLocalStorage.getItem("latestTenant")?.tenantName;
  const [selectedAccess, setSelectedAccess] = useState("resources");
  const [user, setUser] = useState(initialUser);
  const [groups, setGroups] = useState(initialUser?.groups || []);
  const [roleDefinitions, setRoleDefinitions] = useState(
    initialUser?.roleDefinitions || [],
  );
  const syncStatus = useCloudSyncStore((state) => state.syncStatus);
  const [selectedTab, setSelectedTab] = useState("analytics");

  const [subList, setSubList] = useState([]);
  const [selectedSubList, setSelectedSubList] = useState(null);
  const latestSubId = JSON.parse(
    myLocalStorage.getItem("latestSubList"),
  )?.azureSubscriptionId;

   const latestSubName= JSON.parse(
    myLocalStorage.getItem("latestSubList"),
  )?.subscriptionName;


  const latestSubList =
    myLocalStorage.getItem("latestSubList")?.subscriptionName;
  const { role, email } = useUserStore((state) => state.user);

  const {
    azureId,
    syncedAt,
    preferredLanguage,
    azureUserId,
    userPrincipalName,
    mail,
  } = user;
  const analyticsEmail =
    user?.email ||
    mail ||
    user?.userDetails?.mail ||
    user?.userDetails?.userPrincipalName ||
    userPrincipalName ||
    "-";

  const getDisplayItems = (items) =>
    items.map((item) => item.displayName).slice(0, 2);
  const getDisplayRoleItems = (items) => items.map((item) => item).slice(0, 2);
  const getMoreCount = (items) => items.length - 2;
  const getRemainingItems = (roles) => {
    return roles.slice(getDisplayItems(roles).length);
  };

  const handleSync = async () => {
    try {
      const data = await triggerCloudSync(
        "azure",
        "/api/azure-sync/onDemand",
        latestTenant,
      );
      console.log("Azure Sync complete:", data);
    } catch (error) {
      console.error("Azure Sync failed", error);
    }
  };

  const getAllDetails = (val) => {
    setSelectedAccess(val);
  };

  const getSpecificUsers = async () => {
    let id = azureId || azureUserId || null;
    if (id !== null) {
      try {
        const response = await axios.get(
          `${NGROK}/api/azure/v1/users/getRolesAndGroups?tenantName=${latestTenant}&azureId=${id}`,
        );
        if (response?.data) {
          let specificUserdata = response?.data[0];
          setUser(specificUserdata);
          setGroups(specificUserdata?.groups);
          setRoleDefinitions(specificUserdata?.roleDefinitions);
        }
      } catch (e) {}
    }
  };
  const handleSubscriptionChange = (value) => {
    const sub = subList.find((subs) => subs?.name === value);
    if (sub !== undefined) {
      setSelectedSubList(sub);
      myLocalStorage.setItem("latestSubList", sub);
    }
  };

  const fetchUserSubList = async () => {
    try {
      const response = await axios.get(
        `${NGROK}/api/azureResources/v1/users/subscriptions?tenantName=${latestTenant}&userId=${azureId || azureUserId}`,
      );

      const subs = response?.data || [];
      setSubList(subs);

      if (subs.length > 0) {
        let latest = null;

        try {
          latest =
            typeof latestSubList === "string"
              ? JSON.parse(latestSubList)
              : latestSubList;
        } catch (e) {
          latest = null;
        }

        const match = latest
          ? subs.find(
              (item) =>
                item?.name === latest?.name ||
                item?.name === latest?.subscriptionName,
            )
          : null;

        const selected = match || subs[0];

        setSelectedSubList(selected);

        myLocalStorage.setItem("latestSubList", JSON.stringify(selected));
      } else {
        setSelectedSubList(null);
      }
    } catch (error) {
      console.error("Failed to fetch subscriptions:", error);
      setSubList([]);
      setSelectedSubList(null);
    }
  };

  useEffect(() => {
    if (role === "TENANT_USER") {
      setSelectedTab("resources");
      fetchUserSubList();
    } else {
      setSelectedTab("analytics");
    }
    const interval = setInterval(() => {
      getSpecificUsers();
    }, [5000]);
    return () => clearInterval(interval);
  }, [initialUser]);

  return <CloudEntityAnalytics cloudProvider={"azure"} email={analyticsEmail} entityId={azureId || azureUserId || "-"} entityType="user" projectId={latestSubId} roles={initialUser?.roles || []} syncedAt={syncedAt} entityName={latestSubName} details={initialUser} />

};

export default AzureUserInfo;
